module.exports = __webpack_public_path__ + "img/53164-warehouse-stepladder-YVH6DWS.7d264536.jpg";